export default __webpack_public_path__ + "static/media/1492509278_music_ios7_ios_7.59a4e2a0.png";